import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { SETTINGS_HOME_PATH } from "../../config/featureFlags";

export default function SettingsV2Redirect() {
  const location = useLocation();
  const remainder = location.pathname.replace(/^\/settings-v2\/?/, "");

  if (!remainder) {
    return <Navigate to={SETTINGS_HOME_PATH} replace />;
  }

  return (
    <Navigate
      to={`/settings/${remainder}${location.search}${location.hash}`}
      replace
    />
  );
}
